import React from "react";

function Footer() {
  return (
    <footer className="bg-blue-700 text-white py-6 mt-12 flex flex-col items-center gap-2 shadow-inner">
      <div className="font-bold text-lg tracking-wide">AutoIP</div>
      <div className="text-sm opacity-90">Effortless Patent Document Automation</div>
      <div className="flex flex-col md:flex-row gap-2 md:gap-6 items-center mt-2">
        <span className="opacity-80">&copy; {new Date().getFullYear()} AutoIP. All rights reserved.</span>
        <span className="hidden md:inline-block">|</span>
        <a href="mailto:support@autoip.com" className="hover:underline text-blue-200">Contact Us</a>
      </div>
    </footer>
  );
}

export default Footer;
